import React from 'react'

const ToggleButton = ({name = '', disabled = '', toggle = '', onChangeHandler = () => {} }) => {
    const onClickHandler = () => onChangeHandler({ name, value: !toggle })

  return (
    <div className={`${disabled ? 'opacity-50' : ''}`}>
       <button 
         type="button" 
         className={`${toggle ? 'bg-green-700' : 'bg-gray-275'} relative inline-flex flex-shrink-0 h-5 w-9 border-2 border-transparent rounded-full ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`} 
         role="switch" 
         aria-checked="false" 
         onClick={onClickHandler}
         disabled={disabled}
       >
           <span className="sr-only">Use setting</span>
           <span aria-hidden="true" className={`${toggle ? 'translate-x-4' : 'translate-x-0'}  pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span> 
     </button>
    </div>
  )
}

export default ToggleButton